import { useQuery } from "@tanstack/react-query";
import { API, fetcher } from "@/shared/core-configs";
import { CostCenter } from "../types/CostCenter";

const GET_COST_CENTERS_FETCH_KEY = "GET_COST_CENTERS_KEY";

export const getCostCenters = async (zoneId: string): Promise<CostCenter[]> => {
  const response = await fetcher.get(
    `${API.GESLUB_SERVICE}/cost-center?zoneId=${zoneId}`,
  );
  return response.data;
};

export const useGetCostCenters = (zoneId: string) => {
  const { data, isPending, error } = useQuery({
    queryKey: [GET_COST_CENTERS_FETCH_KEY, zoneId],
    queryFn: () => getCostCenters(zoneId),
  });

  return {
    data,
    isPending,
    error,
  };
};
